import dayjs from 'dayjs';
import _ from 'underscore';
import { ActiveOrder, OpenSlot } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';
import { OrderStatus } from 'views/order-feed/types/order-status.enum';

/**
 * Uses Typescript's Type Predicate to define the type of a variable at runtime
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 * @param x
 * @returns
 */
export const isActiveOrder = (x: ActiveOrder | OpenSlot): x is ActiveOrder => {
  return (x as ActiveOrder).orderNumber !== undefined;
};

/** Chile treats Received orders as confirmed. */
export const isConfirmedOrder = (row: ActiveOrder | OpenSlot, isChileMarket: boolean): boolean =>
  isActiveOrder(row) && (row.orderStatus === OrderStatus.Confirmed || (isChileMarket && row.orderStatus === OrderStatus.Received));

export const getArrivalDate = (row: ActiveOrder | OpenSlot): number => {
  if (isActiveOrder(row)) {
    if (row.arrivalTime) return dayjs(row.arrivalTime).valueOf();
    if (row.currentEta) return dayjs(row.currentEta).valueOf();
    if (row.estimatedArrivalDate) return dayjs(row.estimatedArrivalDate).valueOf();
  } else if (row.arrivalDate) {
    return dayjs(row.arrivalDate).valueOf();
  }

  return Infinity;
};

/** Orders and open slots mixed, sorted by dispatch date, then arrival date, then plant id, and finally vessel. */
export const sortStandardOrderRows = (rows: (ActiveOrder | OpenSlot)[]): (ActiveOrder | OpenSlot)[] =>
  _.sortBy(rows, (row: ActiveOrder | OpenSlot) => [dayjs(row.dispatchDate).valueOf(), getArrivalDate(row), row.plantId, row.vessel]);

/** Chile orders have no dispatch date, so orders and open slots are mixed and sorted by the date in the Delivery Date column. */
export const sortChileOrderRows = (rows: (ActiveOrder | OpenSlot)[]): (ActiveOrder | OpenSlot)[] =>
  _.sortBy(rows, (row: ActiveOrder | OpenSlot) => {
    const date = isActiveOrder(row) ? (row.arrivalTime ?? row.currentEta ?? row.deliveryDate) : row.arrivalDate;
    return date ? dayjs(date).valueOf() : Infinity;
  });
